import axios from 'axios';

export default axios.create({
    baseURL: 'https://Apps.shelegcrm.com/bo_ws/api/ShelegAPI',
    //baseURL: 'https://www.shelegmain.net/bo_ws_test/api/ShelegAPI',
    headers: {
        Authorization: '',
        'Content-Type': 'application/json'
    },
    
});